<template>
  <ListagemBase
    nomePlural="SupportSubjects"
    nomeSingular="SupportSubject"
    :headers="headers"
  />
</template>

<script>
import ListagemBase from "@/components/base/Crud/ListagemBase";
import { createSupportSubjectDataService } from "@/services/support/SupportSubjectDataService";

export default {
  name: "ListagemSupportSubjects",
  components: { ListagemBase },
  data() {
    const supportScope =
      this.$route?.meta?.supportScope || this.$route?.query?.escopo || null;
    return {
      DataService: createSupportSubjectDataService(supportScope),
      headers: [
        { text: this.$t("Nome"), value: "nome", sortable: "true" },
        { text: this.$t("Ordem"), value: "ordem", sortable: "true" },
        { text: this.$t("Ativo"), value: "ativo", sortable: "true" },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
};
</script>
